var render = function render(){var _vm=this,_c=_vm._self._c;return _c('w-icon-wrapper',{attrs:{"height":24,"width":18,"icon-name":"work-favorite-filled-icon","view-box":"0 0 18 24"}},[_c('path',{attrs:{"id":"_72_Favoriten_Filled","d":"M21.5.39v24l-9-7-9,7V.39Z","data-name":"72 Favoriten_Filled","fill":"currentColor","transform":"translate(-3.5 -0.39)"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }